export const ITEM_CLASS={
    CLASS_A:'CLASS A',
    CLASS_B:'CLASS B',
    CLASS_D:'CLASS D',
    CLASS_C:'CLASS C',
}